import script from "./CRM05_008INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM05_008INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__